var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRouter = function SvgRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.059 0c1.24 0 2.337.756 2.795 1.882l.064.171 1.211 3.62c.072.236.118.467.137.698l.01.231v4.8c0 1.634-1.533 2.912-3.412 2.998l-.203.005H3.614c-1.97 0-3.614-1.31-3.614-3.003v-4.8c0-.232.029-.461.083-.694l.063-.235 1.209-3.614A3.022 3.022 0 0 1 4.031.006L4.216 0H15.06zm1.38 9.6-.175.005H3.012A3 3 0 0 1 1.204 9v2.402c0 .918.963 1.725 2.235 1.793l.175.005h12.047c1.358 0 2.41-.838 2.41-1.798V9a3 3 0 0 1-1.631.6zm-1.38-8.395H4.216c-.73 0-1.377.436-1.662 1.091l-.053.138-1.207 3.602-.036.138c-.024.1-.04.196-.047.29l-.006.138a1.81 1.81 0 0 0 1.66 1.792l.147.006h13.252a1.81 1.81 0 0 0 1.807-1.798c0-.137-.018-.278-.054-.428l-.038-.14-1.207-3.608-.05-.13a1.815 1.815 0 0 0-1.508-1.085l-.155-.006z"
  })));
};

export default SvgRouter;